export function getEnv() {
  // @ts-ignore
  return window.env;
}
